var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable babel/new-cap */
import { Vue, Component } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
// import { goToLogin } from '../../public'
import { goToPopLogin } from '../utils';
import logger from '@plat-components/utils2/_esm5/logger';
let Page0 = class Page0 extends Vue {
    handleButtonClick() {
        // Vue.prototype.$toast.info(JSON.stringify(this.userInfo))
        logger('button_create');
        if (this.userInfo.isLogin) {
            this.isAgree && this.SET_CURRENT('next');
        }
        else {
            goToPopLogin();
        }
    }
};
__decorate([
    State
], Page0.prototype, "isAgree", void 0);
__decorate([
    State
], Page0.prototype, "userInfo", void 0);
__decorate([
    Mutation
], Page0.prototype, "SET_AGREEMENT", void 0);
__decorate([
    Mutation
], Page0.prototype, "SET_CURRENT", void 0);
__decorate([
    Mutation
], Page0.prototype, "TOGGLE_TOAST", void 0);
Page0 = __decorate([
    Component
], Page0);
export default Page0;
